import styled from 'styled-components';
import { Skeleton } from '@mui/material';

export const StyledFlatfishPlaceholder = styled(Skeleton)`
  width: 80%;
  height: 80%;
`;
